import { render, staticRenderFns } from "./closing-controls.vue?vue&type=template&id=83d6bff6&scoped=true&"
import script from "./closing-controls.vue?vue&type=script&lang=js&"
export * from "./closing-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d6bff6",
  null
  
)

export default component.exports